@if (isInitialized) {
  <oe-flat-widget [title]="component.alias" [icon]="{name: 'flame', color: 'normal'}" button
    [link]="'/device/' + edge.id + newNavigationUrlSegment + '/history/' + component.id + '/heatchart'">
    <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.HEAT.HEATING_ENERGY'| translate"
      [channelAddress]="component.id + '/ActiveProductionEnergy'" [converter]="Utils.CONVERT_TO_KILO_WATTHOURS">
    </oe-flat-widget-line>
  </oe-flat-widget>
}